import { TextInput } from '@dreryk/react-components';

import { extendedDosageTemplatesTranslationKeys } from '../../../../../../../translations';
import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';

import { DOSAGE_TEMPLATE_NAME_MAX_LENGTH } from './TemplateNameField.constants';

type TemplateNameFieldProps = Pick<ExtendedDosageFormController, 'register'>;

export const TemplateNameField = (props: TemplateNameFieldProps): JSX.Element => {
   return (
      <TextInput
         testId={'templateName'}
         label={extendedDosageTemplatesTranslationKeys.name}
         controller={props.register('templateName', { maxLength: DOSAGE_TEMPLATE_NAME_MAX_LENGTH, required: true })}
      />
   );
};
